export enum ECookieKeys {
  TOKEN_ADMIN = "token_admin",
  TOKEN = "token",
  USER_ID = "user_id",
}
